import {useEffect, useCallback} from 'react';
import {initRecaptcha} from '@Libraries/recaptcha-library';
import {setRecaptchaLoaded} from '@Components/login-page/login-page-reducer';
import {useAppDispatch, useAppSelector} from '@/hooks';

export const useIsRecaptchaLoaded = (): boolean => {
  const dispatch = useAppDispatch();
  const isRecaptchaLoaded = useAppSelector((state) => state.loginPage.isRecaptchaLoaded);

  const updateStateOnLoad = useCallback((): void => {
    const textarea: HTMLElement | null = document.getElementById('g-recaptcha-response-100000');
    if (textarea) {
      textarea.setAttribute('aria-hidden', 'true');
      textarea.setAttribute('aria-label', 'do not use');
    }

    dispatch(setRecaptchaLoaded());
  }, [dispatch]);

  useEffect(() => {
    if (!isRecaptchaLoaded) {
      initRecaptcha(updateStateOnLoad);
    }
  }, [isRecaptchaLoaded, updateStateOnLoad]);

  return isRecaptchaLoaded;
};
